@if (!carregando) {
  <div class="dashboard-venda-interna-page" [@esvanecerDesvanecer]="'in'">
    <div class="dashboard-venda-interna-topbar">
      <div>
        <h1>Dashboard &gt; Venda Interna</h1>
        <p>Efetividade das ligacoes, tipos, resultados e faturamento por vendedora interna.</p>
      </div>

      <div class="dashboard-venda-interna-filtros">
        <label>
          <span>Inicio</span>
          <input type="date" [(ngModel)]="dataInicio" [ngModelOptions]="{standalone: true}">
        </label>
        <label>
          <span>Fim</span>
          <input [appPeriodoFinal]="dataInicio" type="date" [(ngModel)]="dataFim" [ngModelOptions]="{standalone: true}">
          @if (erroPeriodo) { <small class="text-danger" role="alert">{{ erroPeriodo }}</small> }
        </label>
        <label>
          <span>Tipo</span>
          <select [(ngModel)]="tipoDados" [ngModelOptions]="{standalone: true}">
            <option value="FATURADO">Faturado</option>
            <option value="GERAL">Geral</option>
          </select>
        </label>
        <button type="button" (click)="atualizar()">Atualizar</button>
      </div>
    </div>

    <div class="dashboard-venda-interna-kpis">
      <div class="dashboard-venda-interna-kpi">
        <span>Ligacoes</span>
        <strong>{{ totalLigacoes() | number: '1.0-0' }}</strong>
      </div>
      <div class="dashboard-venda-interna-kpi">
        <span>Pedidos internos</span>
        <strong>{{ totalPedidosInternosDia() | number: '1.0-0' }}</strong>
      </div>
      <div class="dashboard-venda-interna-kpi">
        <span>Conversao em pedidos</span>
        <strong>{{ conversaoGeral() | number: '1.1-1' }}%</strong>
      </div>
      <div class="dashboard-venda-interna-kpi">
        <span>Faturamento interno</span>
        <strong>{{ totalVendasReais() | currency: 'BRL' }}</strong>
      </div>
    </div>

    <div class="dashboard-venda-interna-grid dashboard-venda-interna-grid-duo">
      <section class="dashboard-venda-interna-panel">
        <div class="dashboard-venda-interna-panel-header">
          <h2>Vendas em reais por dia</h2>
          <span>{{ totalVendasReais() | currency: 'BRL' }}</span>
        </div>

        <div class="dashboard-venda-interna-columns">
          @for (dia of dias; track dia.dia) {
            <div class="dashboard-venda-interna-column-item">
              <div class="dashboard-venda-interna-column-track">
                <div class="dashboard-venda-interna-column dashboard-venda-interna-column-blue" [style.height.%]="altura(dia.vendasReais, maxVendasReaisDia())">
                  <b>{{ dia.vendasReais | number: '1.0-0' }}</b>
                </div>
              </div>
              <span>{{ dia.dia }}</span>
            </div>
          }
        </div>
      </section>

      <section class="dashboard-venda-interna-panel">
        <div class="dashboard-venda-interna-panel-header">
          <h2>Vendas em litros por dia</h2>
          <span>{{ totalLitros() | number: '1.0-0' }} L</span>
        </div>

        <div class="dashboard-venda-interna-columns">
          @for (dia of dias; track dia.dia) {
            <div class="dashboard-venda-interna-column-item">
              <div class="dashboard-venda-interna-column-track">
                <div class="dashboard-venda-interna-column dashboard-venda-interna-column-green" [style.height.%]="altura(dia.litros, maxLitrosDia())">
                  <b>{{ dia.litros | number: '1.0-0' }} L</b>
                </div>
              </div>
              <span>{{ dia.dia }}</span>
            </div>
          }
        </div>
      </section>
    </div>

    <div class="dashboard-venda-interna-grid dashboard-venda-interna-grid-duo">
      <section class="dashboard-venda-interna-panel">
        <div class="dashboard-venda-interna-panel-header">
          <h2>Ligacoes x pedidos por dia</h2>
          <span>{{ conversaoGeral() | number: '1.1-1' }}% conversao</span>
        </div>

        <div class="dashboard-venda-interna-dias">
          <div class="dashboard-venda-interna-dia dashboard-venda-interna-dia-header">
            <b>Dia</b>
            <span></span>
            <div>
              <span>Ligacoes</span>
              <span>Pedidos</span>
              <span>Conversao</span>
            </div>
          </div>
          @for (dia of dias; track dia.dia) {
            <div class="dashboard-venda-interna-dia">
              <b>{{ dia.dia }}</b>
              <div class="dashboard-venda-interna-stack">
                <div class="dashboard-venda-interna-success" [style.width.%]="larguraPedidosDia(dia)"></div>
                <div class="dashboard-venda-interna-danger" [style.width.%]="larguraSemPedidoDia(dia)"></div>
              </div>
              <div class="dashboard-venda-interna-dia-metrics">
                <span>{{ dia.total | number: '1.0-0' }}</span>
                <span>{{ dia.pedidos | number: '1.0-0' }}</span>
                <span>{{ dia.conversao | number: '1.1-1' }}%</span>
              </div>
            </div>
          }
        </div>
      </section>

      <section class="dashboard-venda-interna-panel">
        <div class="dashboard-venda-interna-panel-header">
          <h2>Por tipo de ligacao</h2>
          <span>{{ tipos.length | number: '1.0-0' }} tipos</span>
        </div>

        <div class="dashboard-venda-interna-bars">
          @for (tipo of tipos; track tipo.descricao) {
            <div class="dashboard-venda-interna-bar-row">
              <span>{{ tipo.descricao }}</span>
              <div><b [style.width.%]="largura(tipo.quantidade, maxGrupo(tipos))"></b></div>
              <strong>{{ tipo.quantidade }}</strong>
            </div>
          }
        </div>
      </section>
    </div>

    <div class="dashboard-venda-interna-grid dashboard-venda-interna-grid-duo">
      <section class="dashboard-venda-interna-panel">
        <div class="dashboard-venda-interna-panel-header">
          <h2>Soma dos resultados</h2>
          <span>{{ resultados.length | number: '1.0-0' }} resultados</span>
        </div>

        <div class="dashboard-venda-interna-bars">
          @for (resultado of resultados; track resultado.descricao) {
            <div class="dashboard-venda-interna-bar-row">
              <span>{{ resultado.descricao }}</span>
              <div><b [style.width.%]="largura(resultado.quantidade, maxGrupo(resultados))"></b></div>
              <strong>{{ resultado.quantidade }}</strong>
            </div>
          }
        </div>
      </section>

      <section class="dashboard-venda-interna-panel dashboard-venda-interna-panel-externos">
        <div class="dashboard-venda-interna-panel-header">
          <h2>Ligacoes por vendedor externo</h2>
          <div class="dashboard-venda-interna-panel-actions">
            <label class="dashboard-venda-interna-select">
              <span>Interna</span>
              <select [(ngModel)]="filtroInternaExterno" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">Todas</option>
                @for (interna of internasFiltroExterno(); track interna.id) {
                  <option [ngValue]="interna.id">{{ interna.nome }}</option>
                }
              </select>
            </label>
            <label class="dashboard-venda-interna-select">
              <span>Ordenar por</span>
              <select [(ngModel)]="ordenacaoExternos" [ngModelOptions]="{standalone: true}">
                <option value="valor">R$</option>
                <option value="ligacoes">Ligacoes</option>
                <option value="litros">Litros</option>
                <option value="pedidos">Pedidos</option>
              </select>
            </label>
            <div class="dashboard-venda-interna-totalizadores">
              <span>{{ vendedoresExternosFiltrados().length | number: '1.0-0' }} vendedores</span>
              <span>Ligacoes {{ totalExternoLigacoes() | number: '1.0-0' }}</span>
              <span>{{ totalExternoVendasReais() | currency: 'BRL' }}</span>
              <span>{{ totalExternoLitros() | number: '1.0-0' }} L</span>
              <span>Pedidos {{ totalExternoPedidos() | number: '1.0-0' }}</span>
            </div>
          </div>
        </div>

        <div class="table-responsive dashboard-venda-interna-table-scroll dashboard-venda-interna-table-scroll-externos">
          <table class="table table-sm dashboard-venda-interna-table mb-0">
            <thead>
              <tr>
                <th>Vend interna</th>
                <th>Vend externo</th>
                <th class="text-right">Ligacoes</th>
                <th class="text-right">Vendas R$</th>
                <th class="text-right">Litros</th>
                <th class="text-right">Pedidos</th>
              </tr>
            </thead>
            <tbody>
              @for (item of vendedoresExternosFiltrados(); track item.sellerIdInterna + '-' + item.sellerIdExterno) {
                <tr>
                  <td>{{ item.vendInterna }}</td>
                  <td>{{ item.vendExterno }}</td>
                  <td class="text-right">{{ item.ligacoes | number: '1.0-0' }}</td>
                  <td class="text-right">{{ item.vendasReais | currency: 'BRL' }}</td>
                  <td class="text-right">{{ item.litros | number: '1.0-0' }} L</td>
                  <td class="text-right">{{ item.pedidos | number: '1.0-0' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div class="dashboard-venda-interna-grid dashboard-venda-interna-grid-duo">
      <section class="dashboard-venda-interna-panel">
        <div class="dashboard-venda-interna-panel-header">
          <h2>Faturamento por Vendedora Interna</h2>
          <div class="dashboard-venda-interna-panel-actions">
            <label class="dashboard-venda-interna-select">
              <span>Ordenar por</span>
              <select [(ngModel)]="ordenacaoFaturamento" [ngModelOptions]="{standalone: true}">
                <option value="valor">R$</option>
                <option value="ligacoes">Ligacoes</option>
                <option value="litros">Litros</option>
                <option value="pedidos">Pedidos</option>
              </select>
            </label>
            <span>{{ totalVendasReais() | currency: 'BRL' }}</span>
          </div>
        </div>

        <div class="table-responsive dashboard-venda-interna-table-scroll dashboard-venda-interna-table-scroll-faturamento">
          <table class="table table-sm dashboard-venda-interna-table mb-0">
            <thead>
              <tr>
                <th>Vend interna</th>
                <th class="text-right">Ligacoes</th>
                <th class="text-right">Vendas R$</th>
                <th class="text-right">Litros</th>
                <th class="text-right">Pedidos</th>
              </tr>
            </thead>
            <tbody>
              @for (fat of faturamentoInternoOrdenado(); track fat.sellerIdInterna) {
                <tr>
                  <td>{{ fat.vendInterna }}</td>
                  <td class="text-right">{{ fat.ligacoes | number: '1.0-0' }}</td>
                  <td class="text-right">{{ fat.vendasReais | currency: 'BRL' }}</td>
                  <td class="text-right">{{ fat.litros | number: '1.0-0' }} L</td>
                  <td class="text-right">{{ fat.pedidos | number: '1.0-0' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>

      <section class="dashboard-venda-interna-panel">
        <div class="dashboard-venda-interna-panel-header">
          <h2>Top 50 clientes</h2>
          <div class="dashboard-venda-interna-panel-actions">
            <label class="dashboard-venda-interna-select">
              <span>Ordenar por</span>
              <select [(ngModel)]="ordenacaoClientes" [ngModelOptions]="{standalone: true}">
                <option value="valor">R$</option>
                <option value="ligacoes">Ligacoes</option>
                <option value="litros">Litros</option>
                <option value="pedidos">Pedidos</option>
              </select>
            </label>
            <span>{{ clientes.length | number: '1.0-0' }} clientes</span>
          </div>
        </div>

        <div class="table-responsive dashboard-venda-interna-table-scroll dashboard-venda-interna-table-scroll-faturamento">
          <table class="table table-sm dashboard-venda-interna-table mb-0">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Cidade</th>
                <th class="text-right">Ligacoes</th>
                <th class="text-right">Vendas R$</th>
                <th class="text-right">Litros</th>
                <th class="text-right">Pedidos</th>
              </tr>
            </thead>
            <tbody>
              @for (cliente of clientesOrdenados(); track (cliente && cliente.clienteId ? cliente.clienteId : 0) + '-' + (cliente && cliente.cliente ? cliente.cliente : '')) {
                <tr>
                  <td>{{ cliente.cliente }}</td>
                  <td>{{ cliente.cidade }}</td>
                  <td class="text-right">{{ cliente.ligacoes | number: '1.0-0' }}</td>
                  <td class="text-right">{{ cliente.vendasReais | currency: 'BRL' }}</td>
                  <td class="text-right">{{ cliente.litros | number: '1.0-0' }} L</td>
                  <td class="text-right">{{ cliente.pedidos | number: '1.0-0' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <section class="dashboard-venda-interna-panel dashboard-venda-interna-panel-tipos-interna">
      <div class="dashboard-venda-interna-panel-header">
        <h2>Vendas por vendedora interna e tipo de ligacao</h2>
        <span>{{ tiposPorInterna.length | number: '1.0-0' }} registros</span>
      </div>

      <div class="table-responsive dashboard-venda-interna-table-scroll dashboard-venda-interna-table-scroll-tipos-interna">
        <table class="table table-sm dashboard-venda-interna-table mb-0">
          <thead>
            <tr>
              <th>Tipo</th>
              <th class="text-right">Total</th>
              <th class="text-right">Nao venda</th>
              <th class="text-right">Venda</th>
              <th class="text-right">Venda R$</th>
              <th class="text-right">Litros</th>
            </tr>
          </thead>
          <tbody>
            @for (grupo of tiposPorInternaGrupos; track grupo && grupo.vendInterna ? grupo.vendInterna : 'Sem vendedora') {
              <tr class="dashboard-venda-interna-group-row">
                <td colspan="6">{{ grupo.vendInterna }}</td>
              </tr>
              <tr class="dashboard-venda-interna-group-total-row">
                <td>Total</td>
                <td class="text-right">{{ totalGrupoTipoInterna(grupo, 'total') | number: '1.0-0' }}</td>
                <td class="text-right">{{ totalGrupoTipoInterna(grupo, 'naoVendas') | number: '1.0-0' }}</td>
                <td class="text-right">{{ totalGrupoTipoInterna(grupo, 'vendas') | number: '1.0-0' }}</td>
                <td class="text-right">{{ totalGrupoTipoInterna(grupo, 'vendasReais') | currency: 'BRL' }}</td>
                <td class="text-right">{{ totalGrupoTipoInterna(grupo, 'litros') | number: '1.0-0' }} L</td>
              </tr>
              @for (item of grupo.itens; track (grupo && grupo.vendInterna ? grupo.vendInterna : 'Sem vendedora') + '-' + (item && item.tipo ? item.tipo : 'Sem tipo')) {
                <tr>
                  <td>
                    <span class="dashboard-venda-interna-tipo-badge dashboard-venda-interna-tipo-badge-large" [ngClass]="tipoClasse(item.tipo)" [title]="item.tipo">
                      {{ item.tipo || '-' }}
                    </span>
                  </td>
                  <td class="text-right">{{ totalTipoInterna(item) | number: '1.0-0' }}</td>
                  <td class="text-right">{{ item.naoVendas | number: '1.0-0' }}</td>
                  <td class="text-right">{{ item.vendas | number: '1.0-0' }}</td>
                  <td class="text-right">{{ item.vendasReais | currency: 'BRL' }}</td>
                  <td class="text-right">{{ item.litros | number: '1.0-0' }} L</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </section>

    <section class="dashboard-venda-interna-panel">
      <div class="dashboard-venda-interna-panel-header">
        <h2>Acompanhamento das ligacoes</h2>
        <div class="dashboard-venda-interna-panel-actions">
          <label class="dashboard-venda-interna-select">
            <span>Vend interna</span>
            <select [(ngModel)]="filtroInternaLigacao" [ngModelOptions]="{standalone: true}">
              <option [ngValue]="null">Todas</option>
              @for (interna of internasFiltroLigacoes(); track interna.id) {
                <option [ngValue]="interna.id">{{ interna.nome }}</option>
              }
            </select>
          </label>
          <label class="dashboard-venda-interna-select">
            <span>Resultado</span>
            <select [(ngModel)]="filtroResultadoLigacao" [ngModelOptions]="{standalone: true}">
              <option value="">Todos</option>
              @for (resultado of resultadosFiltroLigacoes(); track resultado) {
                <option [value]="resultado">{{ resultado }}</option>
              }
            </select>
          </label>
          <button type="button" class="dashboard-venda-interna-export-button" (click)="exportarLigacoesExcel()" [disabled]="ligacoesFiltradas().length === 0">Exportar Excel</button>
          <span>{{ ligacoesFiltradas().length | number: '1.0-0' }} registros</span>
        </div>
      </div>

      <div class="table-responsive dashboard-venda-interna-table-scroll dashboard-venda-interna-table-scroll-ligacoes">
        <table class="table table-sm dashboard-venda-interna-table dashboard-venda-interna-ligacoes mb-0">
          <thead>
            <tr>
              <th>Vend interna</th>
              <th>Vend externo</th>
              <th>Tipo</th>
              <th>Origem</th>
              <th>Status</th>
              <th>Data</th>
              <th>Cod ERP</th>
              <th>Cliente</th>
              <th>Cidade</th>
              <th>Check-in</th>
              <th>Check-out</th>
              <th class="text-right">Duracao</th>
              <th>Resultado</th>
              <th>Observacao</th>
            </tr>
          </thead>
          <tbody>
            @for (ligacao of ligacoesFiltradas(); track ligacao.idVisita) {
              <tr>
                <td>{{ ligacao.vendInterna }}</td>
                <td>{{ ligacao.vendExterno }}</td>
                <td>
                  <span class="dashboard-venda-interna-tipo-badge" [ngClass]="tipoClasse(ligacao.tipo)" [title]="ligacao.tipo">
                    {{ ligacao.tipo || '-' }}
                  </span>
                </td>
                <td class="dashboard-venda-interna-origem">{{ origemTexto(ligacao.origem) }}</td>
                <td>
                  <span class="dashboard-venda-interna-status-badge" [ngClass]="statusClasse(ligacao.status)">
                    {{ statusTexto(ligacao.status) }}
                  </span>
                </td>
                <td>{{ ligacao.dataLigacao }}</td>
                <td>{{ ligacao.codigoErpCliente }}</td>
                <td>{{ ligacao.cliente }}</td>
                <td>{{ ligacao.cidade }}</td>
                <td>{{ ligacao.checkIn }}</td>
                <td>{{ ligacao.checkOut }}</td>
                <td class="text-right">{{ ligacao.duracao }} min</td>
                <td>{{ ligacao.resultado }}</td>
                <td>{{ ligacao.observacao }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
    <section class="dashboard-venda-interna-panel">
      <div class="dashboard-venda-interna-panel-header">
        <h2>Ligações concluídas por segmento e vendedora interna</h2>
        <div class="dashboard-venda-interna-panel-actions"><span>{{ segmentos.length }} registros</span></div>
      </div>
      <div class="table-responsive dashboard-venda-interna-table-scroll">
        <table class="table table-sm dashboard-venda-interna-table mb-0">
          <thead><tr>
            <th>Segmento</th><th>Vendedor</th><th class="text-right" title="Ligações concluídas, excluindo os status 1 e 6">Qtd. atendimentos</th>
            <th class="text-right">Agendado</th><th class="text-right">Gerado</th><th class="text-right">Manual</th>
            <th class="text-right">Total vendas R$</th>
            <th class="text-right" title="Total de vendas dividido pela quantidade de pedidos">Ticket médio</th>
            <th class="text-right" title="Quantidade de pedidos dividida pelos atendimentos × 100">Efetividade</th>
          </tr></thead>
          <tbody>
            @for (item of segmentos; track $index) {
              <tr>
                <td>{{ item.segmento }}</td><td>{{ item.vendInterna }}</td>
                <td class="text-right">{{ item.atendimentos | number: '1.0-0' }}</td>
                <td class="text-right">{{ item.agendado | number: '1.0-0' }}</td>
                <td class="text-right">{{ item.gerado | number: '1.0-0' }}</td>
                <td class="text-right">{{ item.manual | number: '1.0-0' }}</td>
                <td class="text-right">{{ item.vendasReais | currency: 'BRL' }}</td>
                <td class="text-right">{{ item.ticketMedio | currency: 'BRL' }}</td>
                <td class="text-right">{{ item.efetividade | number: '1.2-2' }}%</td>
              </tr>
            } @empty {
              <tr><td colspan="9" class="text-center">Nenhum registro no período selecionado.</td></tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  </div>
}
